import styled from 'styled-components';

export const ModalContainer = styled.div`
  width: 100%;
  max-width: 1600px;
  background-color: white;
  border-radius: 8px;
  overflow: hidden;
  margin: 0 auto;
  position: relative;
  display: flex;
  flex-direction: column;
  min-height: 80vh;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);

  @media (max-width: 1400px) {
    max-width: 95vw;
    margin: 0 8px;
    min-height: 80vh;
  }

  @media (max-width: 600px) {
    max-width: 98vw;
    min-height: 90vh;
  }
`;

export const ModalHeader = styled.div`
  padding: 16px 24px;
  border-bottom: 1px solid #e2e8f0;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const ModalTitleContainer = styled.div`
  flex: 1;
`;

export const ModalTitle = styled.h2`
  font-size: 1.25rem;
  font-weight: 600;
  color: #1e293b;
  margin: 0;
`;

export const CloseButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4px;
  color: #64748b;
  border-radius: 4px;
  transition: all 0.2s ease;

  &:hover {
    background-color: #f1f5f9;
    color: #1e293b;
  }
`;

export const ModalContent = styled.div`
  padding: 24px;
  flex: 1 1 auto;
  overflow-y: auto;
  overflow-x: hidden;
  position: relative;

  @media (max-width: 600px) {
    padding: 16px;
  }
`;

export const ModalFooter = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 16px 24px;
  border-top: 1px solid #e2e8f0;

  @media (max-width: 600px) {
    padding: 12px 16px;
  }
`;
